import React from "react";

const Check: React.FC<{
  className?: string;
  background?: string;
  stroke?: string;
}> = ({ className, background = "#E5FAE7", stroke = "#66996F" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Check">
        <rect width="20" height="20" rx="3.33333" fill={background} />
        <path
          id="Vector"
          d="M16.2636 5.68648C16.6246 6.0445 16.6246 6.62592 16.2636 6.98393L8.86978 14.3161C8.50875 14.6741 7.92245 14.6741 7.56142 14.3161L3.86452 10.65C3.50349 10.292 3.50349 9.71059 3.86452 9.35257C4.22554 8.99456 4.81185 8.99456 5.17288 9.35257L8.21704 12.3685L14.9581 5.68648C15.3191 5.32846 15.9054 5.32846 16.2665 5.68648H16.2636Z"
          fill={stroke}
        />
      </g>
    </svg>
  );
};

export default Check;
